import { render } from "./server-status.vue?vue&type=template&id=73735bc3"
import script from "./server-status.vue?vue&type=script&lang=js"
export * from "./server-status.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__